<h1 mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle [ngStyle]="data.isErrorMsg ? errorMsgStyle : infoMsgStyle ">
  {{data.title}}
  <span (click)="onNoClick()" (keydown.enter)="onNoClick()" class="close-btn"><mat-icon>close</mat-icon></span>
</h1>
<div mat-dialog-content>
  <div [innerHTML]="data.content | safeHtml" class="popup-contents"></div>
</div>
<mat-dialog-actions align="center">
  @if (data.showCancel) {
    <button class="btn btn-secondary" (click)="onNoClick()">{{data.cancelText}}</button>
    }&nbsp;&nbsp;
    <button class="btn btn-primary" [ngClass]="{'btn-error':data.isErrorMsg}" [mat-dialog-close]="data.model || 'OK'" cdkFocusInitial>{{data.okText}}</button>
  </mat-dialog-actions>
